import * as d3 from 'd3'
import MathHelpers from '@aytm/app/stats/lib/util/math'

import {
  DOT_RADIUS,
  DOT_RADIUS_SM,
  VIEW_MODES
} from '@aytm/app/stats/page/question-views/hm/components/chart/lib/constants'

import { createSvgRoot } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/svg-root'
import { getSvgDefs } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/svg-defs'
import { getBatchColor } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/utils'

export const drawDots = (container, options) => {
  const { id, answer, image, scale, batches, width, height, onDotMouseOver, onDotMouseOut } = options
  const imageHeight = image?.original?.height
  const commentsByGroups = {}
  const viewMode = VIEW_MODES.DOTS

  if (!answer?.heatmap?.points) {
    return { commentsByGroups }
  }

  const svg = createSvgRoot(container, { id, viewMode, width, height, scale })

  const defs = svg.append('defs')
  defs.html(getSvgDefs(id, viewMode))

  const group = svg.append('g').attr('id', `svg-dots-${id}-group`)

  const allPins = answer.heatmap.points
  const allPinsWithComments = []
  const allPinsWithoutComments = []

  allPins.forEach(p => {
    if (p.comment) {
      allPinsWithComments.push(p)
    } else {
      allPinsWithoutComments.push(p)
    }
  })

  const dotRadius = DOT_RADIUS

  allPinsWithoutComments.forEach(point => {
    drawDot({ group, point, imageHeight, scale, batches, dotRadius })
  })

  const groups = MathHelpers.calcPointsGroups(allPinsWithComments, (dotRadius * 2) / scale)

  groups.forEach((g, indexGroup) => {
    g.forEach(point => {
      commentsByGroups[indexGroup] = commentsByGroups[indexGroup] || []
      commentsByGroups[indexGroup].push({
        text: point.comment,
        path: [id, point.batch.split('b')[1]],
        uid: point.uid
      })

      point.group = indexGroup
      drawDot({
        group,
        point,
        imageHeight,
        scale,
        batches,
        dotRadius,
        indexGroup,
        comments: commentsByGroups[indexGroup],
        onDotMouseOver,
        onDotMouseOut
      })
    })
  })

  return { commentsByGroups }
}

const drawDot = ({
  group,
  point,
  imageHeight,
  scale,
  batches,
  dotRadius,
  indexGroup = null,
  comments = [],
  onDotMouseOver = _ => {},
  onDotMouseOut = _ => {}
}) => {
  const cx = point.x
  const cy = imageHeight - point.y - 1
  const r = dotRadius / scale
  const rsm = DOT_RADIUS_SM / scale
  const batchColor = getBatchColor(point.batch, batches)

  if (indexGroup !== null) {
    const pathOutside = `M ${cx} ${cy} m -${r}, 0 a ${r},${r} 0 1,1 ${r * 2},0 a ${r},${r} 0 1,1 -${r * 2},0`
    const pathInside = `M ${cx} ${cy} m -${rsm}, 0 a ${rsm},${rsm} 0 1,1 ${rsm * 2},0 a ${rsm},${rsm} 0 1,1 -${
      rsm * 2
    },0`

    const dotGroup = group
      .append('g')
      .attr('fill-rule', 'evenodd')
      .style('fill', batchColor)
      .style('stroke', 'url(#dots-gradient-linear)')
      .style('stroke-width', 1 / scale)
      .attr('class', 'hm-dot')
      .attr('data-group', indexGroup)
      .attr('data-cx', cx)
      .attr('data-cy', cy)
      .on('mouseenter', function () {
        const el = d3.select(this)
        onDotMouseOver({
          group: el.attr('data-group'),
          cx: el.attr('data-cx'),
          cy: el.attr('data-cy'),
          comments
        })
      })
      .on('mouseleave', () => onDotMouseOut())

    dotGroup.append('path').attr('d', `${pathOutside}${pathInside}`)
  } else {
    group
      .append('circle')
      .attr('cx', cx)
      .attr('cy', cy)
      .attr('data-cx', cx)
      .attr('data-cy', cy)
      .attr('r', r)
      .style('fill', batchColor)
      .style('stroke', 'url(#dots-gradient-linear)')
      .style('stroke-width', 1 / scale)
  }
}
